export default "__VITE_ASSET__89rCjYg$__"